module.exports = __webpack_public_path__ + "15a94202c9206514c07a7da0c30ecbbd.svg";